import image1 from '../Assets/Product/1.png';
import image2 from "../Assets/Product/2.png";
import image3 from "../Assets/Product/3.png";
import image4 from "../Assets/Product/4.png";
import image5 from "../Assets/Product/5.png";
import image6 from "../Assets/Product/6.png";

const products = [
  {
    id: 1,
    name: "HP",
    price: 7800,
    imgURL: image1,
    category: "Laptop",
    description: "Spexs Ram 8 GB Processor I5 G10",
  },
  {
    id: 2,
    name: "Realme",
    price: 2850,
    imgURL: image2,
    category: "Mobile",
  },
  {
    id: 3,
    name: "Laptop Dell",
    price: 3800,
    imgURL: image3,
    category: "Laptop",
    description: "Spexs Ram 8 GB Processor I5 G10",
  },
  {
    id: 4,
    name: "Acer",
    price: 5500,
    imgURL: image4,
    category: "Laptop",
    description: "Spexs Ram 8 GB Processor I5 G10",
  },
  {
    id: 5,
    name: "IPhone",
    price: 4870,
    imgURL: image5,
    category: "Mobile",
  },
  {
    id: 6,
    name: "Asus",
    price: 7000,
    imgURL: image6,
    category: "Laptop",
    description: "Spexs Ram 8 GB Processor I5 G10",
  },
  
  {
    id: 7,
    name: "HP",
    price: 8000,
    imgURL: image1,
    category: "Laptop",
    description: "Spexs Ram 8 GB Processor I5 G10",
  },
  {
    id: 8,
    name: "Realme",
    price: 3450,
    imgURL: image2,
    category: "Mobile",
  },
  {
    id: 9,
    name: "Dell",
    price: 8500,
    imgURL: image3,
    category: "Laptop",
    description: "Spexs Ram 8 GB Processor I5 G10",
  },
  {
    id: 10,
    name: "Acer",
    price: 9000,
    imgURL: image4,
    category: "Laptop",
    description: "Spexs Ram 8 GB Processor I5 G10",
  },
  {
    id: 11,
    name: "IPhone",
    price: 4500,
    imgURL: image5,
    category: "Mobile",
  },
  {
    id: 12,
    name: "Asus",
    price: 9500,
    imgURL: image6,
    category: "Laptop",
    description: "Spexs Ram 8 GB Processor I5 G10",
  },];

export default products;
